// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_HKgsx","footerInner":"index_footerInner_VbGiE","logo":"index_logo_mv3fd"};